export default "__VITE_ASSET__Y59evr3u__"